// TODO copy: perguntas e respostas escritas para preencher a seção de FAQ.
// Baseadas nos fatos confirmados do briefing (trial, preços, segurança) mas
// a redação em si é nova — revisar tom e completude com o cliente antes de
// publicar.
export type ItemFaq = { pergunta: string; resposta: string };

export const FAQ: readonly ItemFaq[] = [
  {
    pergunta: 'Preciso instalar alguma coisa?',
    resposta:
      'Não. O Specializer Social roda no navegador, em social.specializer.com.br.',
  },
  {
    pergunta: 'Como funciona o teste grátis?',
    resposta:
      '7 dias com acesso completo, sem cartão de crédito. No oitavo dia, sem plano contratado, o sistema para de aceitar cadastro novo até você assinar — o que já foi cadastrado continua visível.',
  },
  {
    pergunta: 'O plano anual é cobrado todo mês?',
    resposta:
      'Não. O anual é uma cobrança única de R$ 838,80 — o "R$ 69,90/mês" é só a comparação com o preço mensal, não 12 parcelas separadas.',
  },
  {
    pergunta: 'Dá para trocar de plano depois?',
    resposta:
      'Sim, a qualquer momento. O valor do ciclo em andamento não muda; o novo plano vale a partir da próxima renovação.',
  },
  {
    pergunta: 'Meus documentos ficam seguros?',
    resposta:
      'O acesso é isolado por escritório, a senha nunca é armazenada em texto puro, e o contrato gerado não sai do seu escritório sem uma ação sua.',
  },
] as const;
